import { Promotion } from "../../../Models/Promotion";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";


export class PromotionsAPIHandler {
    
    public static shared = new PromotionsAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    public async postPromo(promotionData: any): Promise<Promotion> {
        let url = this.serverConfig.promoAPIs.promoAPI;
        let authHeaders = this.networkUtils.addAdminAuthHeaders({});

        try {
            
            let response = await this.apiHandler.makePostRequest(authHeaders, url, promotionData);
            let data = response.data;
            let promotion = new Promotion(data);
            return Promise.resolve(promotion);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async updatePromo(promoId: string, promotionData: any): Promise<Promotion> {
        let url = this.serverConfig.promoAPIs.editPromo(promoId);
        let authHeaders = this.networkUtils.addAdminAuthHeaders({});

        try {
            let response = await this.apiHandler.makePutRequest(authHeaders, url, promotionData);
            let data = response.data;
            let promotion = new Promotion(data);
            return Promise.resolve(promotion);
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async deletePromo(promoId: string): Promise<{ message: string }> {
        let url = this.serverConfig.promoAPIs.deletePromo(promoId);
        let authHeaders = this.networkUtils.addAdminAuthHeaders({});

        try {
            let response = await this.apiHandler.makeDeleteRequest(authHeaders, url, {});
            return Promise.resolve({ message: response.data?.message ?? 'Deleted' });
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getPromoByCode(code: String): Promise<Promotion> {
        let url = this.serverConfig.promoAPIs.promoAPI + code;
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            
            let response = await this.apiHandler.makeGetRequest(authHeaders, url);
            let data = response.data;
            let promotion = new Promotion(data.promotion);
            return Promise.resolve(promotion);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getPromoById(promoId: string): Promise<Promotion> {
        let url = this.serverConfig.promoAPIs.editPromo(promoId);
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            let response = await this.apiHandler.makeGetRequest(authHeaders, url);
            let data = response.data;
            let promotion = new Promotion(data);
            return Promise.resolve(promotion);
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getAllPromos(): Promise<Promotion[]> {
        let url = this.serverConfig.promoAPIs.allPromoAPI;
        let authHeaders = this.networkUtils.addAuthHeaders({});
        
        try {
            
            let response = await this.apiHandler.makeGetRequest(authHeaders, url);
            let data = response.data.promotions as Array<any>;
            let promoArray = data.map((promoJSON) => {
                return new Promotion(promoJSON);
            }) 
            return Promise.resolve(promoArray);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getActivePromos(): Promise<Promotion[]> {
        let url = this.serverConfig.promoAPIs.activePromoAPI;
        let authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            let response = await this.apiHandler.makeGetRequest(authHeaders, url);
            let data = (response.data?.activePromotions ?? response.data) as Array<any>;
            let promoArray = data.map((promoJSON) => new Promotion(promoJSON));
            return Promise.resolve(promoArray);
        } catch (err) {
            return Promise.reject(err);
        }
    }
}